import * as React from 'react';
import {Modal, Button, Icon} from 'semantic-ui-react';
import {translate} from 'react-i18next';

export enum EConfirmTarget {
    FACTORYRESET,
    LOGOUT
}

interface ConfirmDialogProps {
    trigger: JSX.Element;
    target: EConfirmTarget;
    onConfirm: () => void;
    t?: reactI18Next.TranslationFunction;
}

interface ConfirmDialogState {
    open: boolean;
}

class ConfirmDialog extends React.Component<ConfirmDialogProps, ConfirmDialogState> {
    constructor(props: ConfirmDialogProps) {
        super(props);

        this.state = {
            open: false
        };
    }

    private buildContentText() {
        const t = this.props.t as reactI18Next.TranslationFunction<any, object, string>;
        let text: string = "";
        switch (this.props.target) {
            case EConfirmTarget.FACTORYRESET:
                text = t("ARE_YOU_SURE_FACTORY_RESET");
                break;
            case EConfirmTarget.LOGOUT:
                text = t("ARE_YOU_SURE_LOGOUT");
                break;
            default:
                text = "";
                break;
        }
        return text;
    }

    public render() {
        const t = this.props.t as reactI18Next.TranslationFunction<any, object, string>;
        return (
            <Modal
                trigger={this.props.trigger}
                open={this.state.open}
                onClose={() => this.setState({open: false})}
                onOpen={() => this.setState({open: true})}
                basic={true}
                size='small'
            >
                <Modal.Content>
                    <h3>{this.buildContentText()}</h3>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        color='green'
                        onClick={() => {
                            this.props.onConfirm();
                            this.setState({open: false});
                        }}
                        inverted={true}
                    >
                        <Icon name='checkmark' /> {t("OK")}
                    </Button>
                    <Button color='red' onClick={() => this.setState({open: false})} inverted={true}>
                        <Icon name='checkmark' /> {t("CANCEL")}
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default translate(['GLOBAL'])(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/ConfirmDialog.tsx